import React, { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { Select } from "antd";
import "react-phone-input-2/lib/style.css";
import "./MemberSetupPhone.scss";
import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";

import LoginHeader from "../../common/LoginHeader";
import SwoodleFooter from "../../common/SwoodleFooter";
import PrimaryButton from "../../common/PrimaryButton";
import SearchableSelect from "../../common/SearchableSelect";
import { BsInfoCircle } from "react-icons/bs";
import {
  checkout,
  getSubscriptionPlans,
} from "../../../services/subscriptionService";
import {
  sendSignupOtp,
  verifySignupOtp,
  signUp,
  login,
  saveMemberSignupDraft,
} from "../../../services/authService";
import {
  getFundraiserCategories,
  getFundraisersByCategoryId,
  getSubCategoriesByCategoryId,
  getFundraisersBySubCategoryId,
  getFundraiserContent,
  updateReferredBy,
} from "../../../services/fundraiserService";
import {
  clearMemberFundraiserPickerData,
  clearMemberFundraiserResults,
} from "../../../redux/slices/fundraiserSlice";
import toast from "../../../utils/toast";
import { getTokenData } from "../../../utils/connectStore";
import { sortedVictorianSuburbs } from "../../../utils/victorianSuburbs";
import { fetchSuburbsByState } from "../../../services/locationLookupService";

const DesktopView = () => {
  const MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER = [
    "Schools",
    "Sporting Clubs",
    "Community Organisations",
  ];
  const MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY = [
    "Schools",
    "Sporting Clubs",
  ];

  const getExistingEmailInlineMessage = (role) => {
    switch (String(role || "").toLowerCase()) {
      case "member":
      case "user":
        return "This email is already registered. Please log in through the mobile app to continue.";
      case "merchant":
        return "This email is registered as a merchant account.";
      case "fundraiser":
        return "This email is registered as a fundraiser account.";
      case "admin":
        return "This email is registered as an admin account.";
      default:
        return "This email is already registered.";
    }
  };

  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const STRIPE_CHECKOUT_URL = process.env.REACT_APP_STRIPE_CHECKOUT_URL || "";
  useEffect(() => {
    console.log("Clearing signup state");
    localStorage.removeItem("email");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("newMemberData");
    localStorage.removeItem("fundraiserCategories");
    localStorage.removeItem("subscriptionPlans");
    localStorage.removeItem("memberSetup.step");
    setEmail("");
  }, []);

  const clearMemberSetupProgress = () => {
    [
      "memberSetup.step",
      "memberSetup.email",
      "userProfile",
      "userPassword",
      "memberSetup.fund",
    ].forEach((key) => localStorage.removeItem(key));
  };

  const resetMemberDraftState = () => {
    setFirstName("");
    setLastName("");
    setAge("");
    setPhone("");
    setGender(genderOptions[0]);
    pendingDraftSuburbRef.current = "";
    setSuburb("");
    setSelectedState("");
    setPostalCode("");
    setPassword("");
    setConfirmPassword("");
    setFundCategory("");
    setFundSubcat("");
    setFundSubcatIds([]);
    setFundName("");
    setSelectedFundraiserId(null);
  };

  const { loading: authLoading = false } = useSelector(
    (state) => state?.authReducer || {},
  );
  const { loading: subscriptionLoading = false } = useSelector(
    (state) => state?.subscriptionReducer || {},
  );
  const authReducer = useSelector((state) => state?.authReducer || {});
  console.log("state", authReducer);
  // const invitedEmail = useSelector((state)=> state?.onboardingReducer?.fundraiserInviteSent?.email);
  const inEmail = useSelector(
    (state) => state?.onboardingReducer?.fundraiserInviteSent?.email,
  );
  const invitedEmail = inEmail;
  const {
    fundraiserCategories: categories = [],
    subCategories = [],
    fundraisers = [],
    loading: fundraiserLoading = false,
  } = useSelector((state) => state?.fundraiserReducer || {});

  const emailInputRef = useRef(null);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [suppressPersist, setSuppressPersist] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const pendingDraftSuburbRef = useRef("");
  const [step, setStep] = useState(0);
  const [awaitingOtp, setAwaitingOtp] = useState(false);
  const [emailExists, setEmailExists] = useState("");
  // Profile name state with basic validation (letters, spaces, hyphens, apostrophes)
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nameErrors, setNameErrors] = useState({ first: false, last: false });
  const [validationErrors, setValidationErrors] = useState([]);
  const [password, setPassword] = useState("");
  const [profileLoading, setProfileLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [age, setAge] = useState("");
  const [phone, setPhone] = useState("");
  const nameRegex = /^[A-Za-z\s'-]*$/;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Individual field errors
  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    suburb: "",
    password: "",
    confirmPassword: "",
    selectedState: "",
    postalCode: "",
  });

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    if (nameRegex.test(value)) {
      setFirstName(value);
      setNameErrors((s) => ({ ...s, first: false }));
      if (fieldErrors.firstName)
        setFieldErrors((s) => ({ ...s, firstName: "" }));
    } else {
      setNameErrors((s) => ({ ...s, first: true }));
    }
  };

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    if (nameRegex.test(value)) {
      setLastName(value);
      setNameErrors((s) => ({ ...s, last: false }));
      if (fieldErrors.lastName) setFieldErrors((s) => ({ ...s, lastName: "" }));
    } else {
      setNameErrors((s) => ({ ...s, last: true }));
    }
  };
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpTimeLeft, setOtpTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const otpRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  // Suburbs are loaded after selecting a state
  const [suburbOptions, setSuburbOptions] = useState([]);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburb, setSuburb] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const stateOptions = [
    { label: "Australian Capital Territory (ACT)", value: "ACT" },
    { label: "New South Wales", value: "NSW" },
    { label: "Northern Territory (NT)", value: "NT" },
    { label: "Queensland", value: "QLD" },
    { label: "South Australia", value: "SA" },
    { label: "Tasmania", value: "TAS" },
    { label: "Victoria", value: "VIC" },
    { label: "Western Australia", value: "WA" },
  ];
  // Gender dropdown
  const genderOptions = ["Male", "Female", "Other"];
  const [gender, setGender] = useState(genderOptions[0]);
  const [genderOpen, setGenderOpen] = useState(false);
  // Subscription dropdowns
  const [fundCategory, setFundCategory] = useState("");
  const [fundSubcat, setFundSubcat] = useState("");
  const [fundSubcatOpen, setFundSubcatOpen] = useState(false);
  const [fundName, setFundName] = useState("");
  const [fundraiserNameSearch, setFundraiserNameSearch] = useState("");
  const [showSkipModal, setShowSkipModal] = useState(false);
  const [fundSubcatIds, setFundSubcatIds] = useState([]);
  const [skipAutoSelect, setSkipAutoSelect] = useState(false);
  const [selectedFundraiserId, setSelectedFundraiserId] = useState(null);
  const memberVisibleFundraiserCategoryOptions = useMemo(
    () =>
      [
        ...MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER.map((title) =>
          (categories || []).find((category) => category?.title === title),
        ).filter(Boolean),
        ...(categories || []).filter(
          (category) =>
            category?.title &&
            !MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER.includes(category.title),
        ),
      ].map((category) => ({
        label: category?.title || "",
        value: category?.title || "",
      })),
    [categories],
  );
  const selectedCategoryRequiresSubcategory =
    MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY.includes(fundCategory);

  // Load fundraiser categories on component mount
  useEffect(() => {
    dispatch(getFundraiserCategories({ memberSignup: true }));
  }, [dispatch]);

  // Persist current step so refresh returns to same page
  useEffect(() => {
    const savedStep = parseInt(
      localStorage.getItem("memberSetup.step") || "",
      10,
    );
    if (!Number.isNaN(savedStep) && savedStep >= 0 && savedStep <= 3) {
      setStep(savedStep);
    }
    // If stored email belongs to a different invite, clear old state
    try {
      const savedEmail = localStorage.getItem("memberSetup.email");
      if (
        invitedEmail &&
        savedEmail &&
        savedEmail.toLowerCase() !== String(invitedEmail).toLowerCase()
      ) {
        localStorage.removeItem("memberSetup.step");
        localStorage.removeItem("memberSetup.email");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("userPassword");
        localStorage.removeItem("memberSetup.fund");
      }
      if (invitedEmail && !savedEmail) {
        setEmail(invitedEmail);
      }
    } catch (_) {}
  }, []);
  // REFS FOR DROPDOWNS (Click-outside-to-close)
  const genderRef = useRef(null);
  const fundSubcatRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (genderRef.current && !genderRef.current.contains(event.target))
        setGenderOpen(false);
      if (
        fundSubcatRef.current &&
        !fundSubcatRef.current.contains(event.target)
      )
        setFundSubcatOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Load subscription plans and fundraiser data when reaching subscription step
  useEffect(() => {
    if (step === 3) {
      // Reset fundraiser selections when entering subscription step
      setSkipAutoSelect(true);
      setFundCategory("");
      setFundSubcat("");
      setFundSubcatIds([]);
      setFundName("");
      setSelectedFundraiserId(null);
      // Ensure subscription plans and categories are loaded
      dispatch(getSubscriptionPlans({}));
      dispatch(getFundraiserCategories({ memberSignup: true }));
    }
  }, [step, dispatch]);

  // Load subscription plans for final step checkout
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const result = await dispatch(getSubscriptionPlans({})).unwrap();
        if (!isMounted) return;
        if (result?.success === true && Array.isArray(result?.data)) {
          setSubscriptionPlans(result.data);
          // default to first plan (premium) if none selected
          if (!selectedPlan && result.data.length > 0) {
            setSelectedPlan(result.data[0]);
          }
        }
      } catch (e) {
        // ignore; UI will show limited info
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!awaitingOtp) return;
    if (otpTimeLeft <= 0) {
      setCanResend(true);
      return;
    }
    const t = setTimeout(() => setOtpTimeLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [awaitingOtp, otpTimeLeft]);

  useEffect(() => {
    let cancelled = false;
    const preservedSuburb = pendingDraftSuburbRef.current;

    // Reset suburb whenever state changes
    if (!preservedSuburb) {
      setSuburb("");
    }
    setFieldErrors((prev) => ({ ...prev, suburb: "" }));

    if (!selectedState) {
      setSuburbOptions([]);
      setSuburbLoading(false);
      return () => {
        cancelled = true;
      };
    }

    (async () => {
      setSuburbLoading(true);
      try {
        const suburbs = await fetchSuburbsByState(selectedState);
        if (cancelled) return;
        setSuburbOptions(suburbs);
        if (pendingDraftSuburbRef.current) {
          setSuburb(pendingDraftSuburbRef.current);
          pendingDraftSuburbRef.current = "";
        }
      } catch (e) {
        if (cancelled) return;
        // Soft fallback for VIC so the flow still works if the endpoint isn't available yet
        if (String(selectedState).toUpperCase() === "VIC") {
          setSuburbOptions(sortedVictorianSuburbs);
        } else {
          setSuburbOptions([]);
        }
        if (pendingDraftSuburbRef.current) {
          setSuburb(pendingDraftSuburbRef.current);
          pendingDraftSuburbRef.current = "";
        }
      } finally {
        if (!cancelled) setSuburbLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedState]);

  useEffect(() => {
    const resetScrollPosition = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    resetScrollPosition();
    const frame = window.requestAnimationFrame(resetScrollPosition);

    return () => window.cancelAnimationFrame(frame);
  }, [step]);

  // Do not auto-select a fundraiser category. Wait for the user to choose one.
  useEffect(() => {
    if (categories?.length > 0 && !fundCategory && !skipAutoSelect) {
      dispatch(clearMemberFundraiserPickerData());
    }
  }, [
    categories,
    fundCategory,
    skipAutoSelect,
    dispatch,
    memberVisibleFundraiserCategoryOptions,
  ]);

  // Set initial subcategory when data loads
  useEffect(() => {
    if (skipAutoSelect) return;
    // no auto-select; wait for user
  }, [subCategories, skipAutoSelect]);

  // Set initial fundraiser when data loads
  useEffect(() => {
    if (fundraisers && fundraisers.length > 0 && !fundName) {
      // do not auto-select; keep blank for clarity
    }
  }, [fundraisers, fundName]);

  // API Functions
  const handleEmailVerification = async () => {
    try {
      const normalizedEmail = String(email || "")
        .trim()
        .toLowerCase();
      const savedEmail = String(localStorage.getItem("memberSetup.email") || "")
        .trim()
        .toLowerCase();
      if (normalizedEmail && savedEmail && normalizedEmail !== savedEmail) {
        ["userProfile", "userPassword", "memberSetup.fund"].forEach((key) =>
          localStorage.removeItem(key),
        );
        resetMemberDraftState();
      }
      const result = await dispatch(sendSignupOtp({ email }));
      if (result.payload?.success) {
        setAwaitingOtp(true);
        setOtpTimeLeft(60);
        setCanResend(false);
        setEmailExists("");
        toast.success("OTP sent to your email");
      } else {
        // Check if the error is about email already existing
        const errorMessage = result.payload?.message || "Failed to send OTP";
        const existingRole = result.payload?.role;
        if (
          errorMessage.toLowerCase().includes("already exists") ||
          errorMessage.toLowerCase().includes("already registered")
        ) {
          const existingEmailMessage =
            getExistingEmailInlineMessage(existingRole);
          setEmailExists(existingEmailMessage);
          toast.error(existingEmailMessage);
        } else {
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      toast.error("Failed to send OTP");
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const cleanData = pastedData.replace(/\D/g, "").slice(0, 6);

    if (cleanData.length === 6) {
      const newOtp = cleanData.split("");
      setOtp(newOtp);
      // Focus on the last field
      otpRefs[5].current?.focus();
    }
  };

  const handleOtpInputChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
    const next = [...otp];
    next[index] = val;
    setOtp(next);

    if (val && index < 5) {
      otpRefs[index + 1].current?.focus();
    }
  };

  const handleLoginClick = () => {
    handleSkipLoginDeepLink();
  };

  // Deep link back to the mobile/host app and try to close the browser/webview
  const handleSkipLoginDeepLink = () => {
    const deeplink = process.env.REACT_APP_APP_DEEPLINK || "swoodle://open";
    const fallbackDeeplink =
      process.env.REACT_APP_APP_LOGIN_DEEPLINK || "swoodle://login";
    try {
      if (window?.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "NAVIGATE", url: deeplink }),
        );
      }
      window.location.assign(deeplink);
      setTimeout(() => {
        try {
          window.location.assign(fallbackDeeplink);
        } catch (_) {}
      }, 150);
    } catch (_) {}
    setTimeout(() => {
      try {
        window.close();
      } catch (_) {}
    }, 600);
  };

  // Validation functions
  const validateProfileStep = () => {
    const newFieldErrors = {
      firstName: "",
      lastName: "",
      age: "",
      phone: "",
      suburb: "",
      selectedState: "",
      postalCode: "",
    };

    let hasErrors = false;

    if (!firstName.trim()) {
      newFieldErrors.firstName = "First name is required";
      hasErrors = true;
    } else if (!nameRegex.test(firstName)) {
      newFieldErrors.firstName = "First name contains invalid characters";
      hasErrors = true;
    }

    if (!lastName.trim()) {
      newFieldErrors.lastName = "Last name is required";
      hasErrors = true;
    } else if (!nameRegex.test(lastName)) {
      newFieldErrors.lastName = "Last name contains invalid characters";
      hasErrors = true;
    }

    if (!age.trim()) {
      newFieldErrors.age = "Age is required";
      hasErrors = true;
    } else if (isNaN(age) || parseInt(age) < 5 || parseInt(age) > 95) {
      newFieldErrors.age = "Age must be between 5 and 95";
      hasErrors = true;
    }

    if (!phone.trim()) {
      newFieldErrors.phone = "Phone number is required";
      hasErrors = true;
    } else if (phone.length < 10) {
      newFieldErrors.phone = "Please enter a valid phone number";
      hasErrors = true;
    }

    if (!suburb.trim()) {
      newFieldErrors.suburb = "Suburb is required";
      hasErrors = true;
    }

    if (!selectedState) {
      newFieldErrors.selectedState = "State is required";
      hasErrors = true;
    }

    setFieldErrors((prev) => ({ ...prev, ...newFieldErrors }));
    return !hasErrors;
  };

  const validatePasswordStep = () => {
    const newFieldErrors = {
      password: "",
      confirmPassword: "",
    };

    let hasErrors = false;

    if (!password.trim()) {
      newFieldErrors.password = "Password is required";
      hasErrors = true;
    } else if (password.length < 8) {
      newFieldErrors.password = "Password must be at least 8 characters long";
      hasErrors = true;
    } else if (!/(?=.*[0-9])/.test(password)) {
      newFieldErrors.password = "Password must contain at least one number";
      hasErrors = true;
    } else if (!/(?=.*[!@#$%^&*])/.test(password)) {
      newFieldErrors.password =
        "Password must contain at least one special character";
      hasErrors = true;
    }

    if (!confirmPassword.trim()) {
      newFieldErrors.confirmPassword = "Please confirm your password";
      hasErrors = true;
    } else if (password !== confirmPassword) {
      newFieldErrors.confirmPassword = "Passwords do not match";
      hasErrors = true;
    }

    setFieldErrors((prev) => ({ ...prev, ...newFieldErrors }));
    return !hasErrors;
  };

  const validatePasswordOnly = () => {
    let message = "";
    if (!password.trim()) message = "Password is required";
    else if (password.length < 8)
      message = "Password must be at least 8 characters long";
    else if (!/(?=.*[0-9])/.test(password))
      message = "Password must contain at least one number";
    else if (!/(?=.*[!@#$%^&*])/.test(password))
      message = "Password must contain at least one special character";
    setFieldErrors((prev) => ({ ...prev, password: message }));
  };
  const validateConfirmOnly = () => {
    let message = "";
    if (!confirmPassword.trim()) message = "Please confirm your password";
    else if (password !== confirmPassword) message = "Passwords do not match";
    setFieldErrors((prev) => ({ ...prev, confirmPassword: message }));
  };

  const saveProfileData = async () => {
    // Here you would typically save to backend or local storage
    const profileData = {
      firstName,
      lastName,
      age,
      phone,
      suburb,
      gender,
      state: selectedState,
      postalCode,
    };

    // For now, we'll just log it and save to localStorage
    console.log("Saving profile data:", profileData);
    localStorage.setItem("userProfile", JSON.stringify(profileData));
  };

  const savePasswordData = async () => {
    // Here you would typically save to backend
    const passwordData = {
      password,
      confirmPassword,
    };

    // For now, we'll just log it and save to localStorage
    console.log("Saving password data:", { password: "***hidden***" });
    localStorage.setItem("userPassword", JSON.stringify(passwordData));
  };

  const handleOtpVerification = async () => {
    try {
      const result = await dispatch(
        verifySignupOtp({
          email,
          otp: otp.join(""),
        }),
      );
      if (result.payload?.success) {
        const draft = result.payload?.data?.draft;
        const profile = draft?.profile;

        if (profile) {
          setFirstName(profile.firstName || "");
          setLastName(profile.lastName || "");
          setAge(String(profile.age ?? ""));
          setPhone(profile.phone || "");
          setGender(
            profile.gender
              ? profile.gender.charAt(0).toUpperCase() + profile.gender.slice(1)
              : genderOptions[0],
          );
          pendingDraftSuburbRef.current = profile.suburb || "";
          setSelectedState(profile.state || "");
          setPostalCode(profile.postalCode || "");
          localStorage.setItem(
            "userProfile",
            JSON.stringify({
              firstName: profile.firstName || "",
              lastName: profile.lastName || "",
              age: String(profile.age ?? ""),
              phone: profile.phone || "",
              suburb: profile.suburb || "",
              gender: profile.gender || "",
              state: profile.state || "",
              postalCode: profile.postalCode || "",
            }),
          );
        } else {
          localStorage.removeItem("userProfile");
          localStorage.removeItem("userPassword");
          localStorage.removeItem("memberSetup.fund");
          resetMemberDraftState();
        }

        setStep(draft?.currentStep === 2 ? 2 : 1);
        toast.success("Email verified successfully");
      } else {
        toast.error(result.payload?.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error("OTP verification failed");
    }
  };

  const handleFundraiserCategoryChange = async (category) => {
    setFundCategory(category);
    setFundSubcat("");
    setFundSubcatIds([]);
    setFundName("");
    setFundraiserNameSearch("");
    setSelectedFundraiserId(null);
    dispatch(clearMemberFundraiserPickerData());

    const categoryData = categories?.find((c) => c.title === category);
    const catId = categoryData?._id || categoryData?.id;
    if (!MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY.includes(category)) {
      await dispatch(
        getFundraisersByCategoryId({
          categoryId: catId,
          categoryTitle: category,
        }),
      );
      return;
    }

    if (catId) {
      dispatch(getSubCategoriesByCategoryId({ id: catId }));
    }
  };

  const toggleSubCategory = async (subCategory) => {
    setFundName("");
    setSelectedFundraiserId(null);
    const subCategoryData = (subCategories || []).find(
      (s) => s.title === subCategory,
    );
    const subId = subCategoryData?._id || subCategoryData?.id;
    if (!subId) return;
    setFundSubcatIds((prev) => {
      const exists = prev.includes(subId);
      const next = exists
        ? prev.filter((id) => id !== subId)
        : [...prev, subId];
      const titles = (subCategories || [])
        .filter((s) => next.includes(s._id || s.id))
        .map((s) => s.title);
      setFundSubcat(titles.join(", "));
      dispatch(clearMemberFundraiserResults());
      if (next.length > 0) {
        clearTimeout(window.__SUBCAT_FETCH_TIMER_DESKTOP__);
        window.__SUBCAT_FETCH_TIMER_DESKTOP__ = setTimeout(() => {
          dispatch(getFundraisersBySubCategoryId({ subCategories: next }));
        }, 250);
      }
      return next;
    });
  };

  const removeSubCategoryChip = (subId) => {
    setFundSubcatIds((prev) => {
      const next = prev.filter((id) => id !== subId);
      const titles = (subCategories || [])
        .filter((s) => next.includes(s._id || s.id))
        .map((s) => s.title);
      setFundSubcat(titles.join(", "));
      dispatch(clearMemberFundraiserResults());
      if (next.length > 0) {
        clearTimeout(window.__SUBCAT_FETCH_TIMER_DESKTOP__);
        window.__SUBCAT_FETCH_TIMER_DESKTOP__ = setTimeout(() => {
          dispatch(getFundraisersBySubCategoryId({ subCategories: next }));
        }, 250);
      }
      return next;
    });
  };

  const handleFundraiserNameChange = async (name) => {
    setFundName(name);
    const cleaned = String(name || "").trim();
    if (!cleaned) {
      setSelectedFundraiserId(null);
      return;
    }

    const fundraiserData = (fundraisers || []).find((f) => {
      const rawLabel =
        f?.user?.name || f?.title || f?.name || f?.businessName || "";
      const label = String(rawLabel || "").trim();
      return label && label === cleaned;
    });

    const userId =
      fundraiserData?.user?._id || fundraiserData?._id || fundraiserData?.id;
    if (!userId) {
      // Ignore random typed text / Enter that doesn't map to an option.
      setFundName("");
      setSelectedFundraiserId(null);
      return;
    }

    setSelectedFundraiserId(userId);
    dispatch(getFundraiserContent({ userId }));
    // If user is already logged in (which they should be by step 3), try to update referral immediately
    if (getTokenData()) {
      dispatch(updateReferredBy({ referredBy: userId }))
        .unwrap()
        .catch(() => {});
    }
  };

  const blurActiveSelect = () => {
    setTimeout(() => {
      if (
        document?.activeElement &&
        typeof document.activeElement.blur === "function"
      ) {
        document.activeElement.blur();
      }
    }, 0);
  };

  const fundraiserOptions = (fundraisers || [])
    .map((f) => {
      const rawLabel =
        f?.user?.name || f?.title || f?.name || f?.businessName || "";
      const label = String(rawLabel || "").trim();
      if (!label) return null;
      const id = f?._id || f?.id || label;
      return { value: label, label, key: id };
    })
    .filter(Boolean)
    .sort((a, b) =>
      a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase()),
    );

  const handleProfileProceed = async () => {
    const isValid = validateProfileStep();
    if (!isValid) return;
    setProfileLoading(true);
    await saveProfileData();
    try {
      const payload = {
        email: (email || invitedEmail || "").trim(),
        firstName,
        lastName,
        age: parseInt(age, 10),
        phone,
        gender: gender.toLowerCase(),
        suburb,
        state: selectedState,
        postalCode,
      };
      await dispatch(saveMemberSignupDraft(payload)).unwrap();
      setStep(2);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to save your signup progress.";
      if (String(message).toLowerCase().includes("already exists")) {
        clearMemberSetupProgress();
        setAwaitingOtp(false);
        setOtp(["", "", "", "", "", ""]);
        setStep(0);
        toast.error(
          "This email is already registered. Please log in to continue.",
        );
        return;
      }
      toast.error(message);
    } finally {
      setProfileLoading(false);
    }
  };

  const handlePasswordProceed = async () => {
    const isValid = validatePasswordStep();
    if (!isValid) return;
    await savePasswordData();
    try {
      const fullName = `${firstName || ""} ${lastName || ""}`.trim() || email;
      const verificationCode = otp.join("");
      const signupEmail = (email || invitedEmail || "").trim();
      const isValidEmail = /[^\s@]+@[^\s@]+\.[^\s@]+/.test(signupEmail);
      if (isValidEmail) {
        const payload = {
          name: fullName,
          password,
          code: verificationCode,
          email: signupEmail,
          age: parseInt(age, 10),
          phone,
          gender: gender.toLowerCase(),
          suburb,
          state: selectedState,
          postalCode,
        };
        await dispatch(signUp(payload))
          .unwrap()
          .catch(() => {});
      }
    } catch (_) {}
    setStep(3);
  };

  const handleCheckoutProceed = async () => {
    try {
      const priceId = selectedPlan?.priceId || subscriptionPlans?.[0]?.priceId;
      if (!priceId) {
        toast.error("Subscription plans unavailable. Please try again later.");
        return;
      }
      try {
        if (!getTokenData()) {
          const loginEmail = (email || invitedEmail || "").trim();
          if (loginEmail && password) {
            await dispatch(login({ email: loginEmail, password })).unwrap();
            await new Promise((r) => setTimeout(r, 500));
          }
        }
      } catch (loginErr) {
        console.error("Background login failed", loginErr);
      }
      if (selectedFundraiserId) {
        dispatch(
          updateReferredBy({ referredBy: String(selectedFundraiserId) }),
        );
      } else if (fundName) {
        const fundraiserData = (fundraisers || []).find(
          (c) =>
            (c?.user?.name ||
              c?.title ||
              c?.name ||
              c?.businessName ||
              "Untitled") === fundName,
        );
        const fid =
          fundraiserData?.user?._id ||
          fundraiserData?._id ||
          fundraiserData?.id;
        if (fid) dispatch(updateReferredBy({ referredBy: String(fid) }));
      }
      const customerEmail = (email || invitedEmail || "").trim();
      const data = await dispatch(
        checkout({
          priceId: String(priceId),
          email: customerEmail,
          referredBy: selectedFundraiserId
            ? String(selectedFundraiserId)
            : undefined,
        }),
      ).unwrap();
      const url =
        data?.data?.url || data?.url || data?.sessionUrl || data?.session?.url;
      if (url) {
        window.location.replace(url);
      } else {
        toast.error("Checkout session not available. Please try again.");
      }
    } catch (e) {
      console.error("Checkout error", e);
      toast.error("Unable to process checkout. Please try again.");
    }
  };

  const onGlobalSubmit = async (e) => {
    if (e) e.preventDefault();
    if (step === 0) {
      if (awaitingOtp) {
        if (otp.join("").length === 6 && !authLoading) handleOtpVerification();
      } else {
        if (email && !authLoading) handleEmailVerification();
      }
    } else if (step === 1) {
      if (!profileLoading) handleProfileProceed();
    } else if (step === 2) {
      if (!authLoading) handlePasswordProceed();
    } else if (step === 3) {
      if (!subscriptionLoading) handleCheckoutProceed();
    }
  };

  return (
    <form onSubmit={onGlobalSubmit}>
      <div className="min-h-screen bg-white">
        {/* Responsive Header matching the design - fully rounded with spacing */}
        <div className="w-full px-6 py-4">
          <div
            style={{
              width: "100%",
              maxWidth: "min(1920px, calc(100vw - 2vw))",
              margin: "0 auto",
            }}
          >
            <LoginHeader />
          </div>
        </div>
        <div className="flex flex-col items-center w-full relative z-[1] pb-20">
          {/* Offer Builder style stepper (4 steps) */}
          <div className="w-full max-w-[840px] mx-auto mt-10 mb-10 px-6">
            <div className="flex items-center justify-between w-full">
              {["Email", "Profile", "Password", "Subscription"].map(
                (label, idx) => (
                  <div
                    key={label}
                    className="w-full relative flex flex-col items-center h-[80px]"
                  >
                    <div
                      className={`${idx <= step ? "bg-[#00ADEF] border-0 text-white" : "bg-white text-[#C4C4C4] border border-[#C4C4C4]"} text-[16px] lg:text-[20px] h-[30px] w-[30px] lg:h-[40px] lg:w-[40px] flex justify-center items-center rounded-full z-10`}
                    >
                      {idx + 1}
                    </div>
                    <p
                      className={`sm:text-[10px] md:text-[12px] mt-2 text-[#303030] font-[400] text-center`}
                    >
                      {label}
                    </p>
                    {idx < 3 && (
                      <div
                        className={`absolute top-[14px] lg:top-[18px] left-[55%] right-[-45%] h-[2px] bg-[#C4C4C4]`}
                      ></div>
                    )}
                  </div>
                ),
              )}
            </div>
          </div>

          <div className="w-full max-w-[640px] mx-auto">
            {step === 0 && (
              <div className="w-full max-w-[640px] mx-auto">
                <h2 className="text-center text-[28px] font-[700] font-poppins text-[#303030]">
                  {awaitingOtp ? "Check your email" : "Get Started"}
                </h2>
                <p className="text-center text-[#8C8C8C] mt-2">
                  {awaitingOtp
                    ? `To confirm your email address, please enter the OTP we sent to ${email}`
                    : "Enter your email to create your account."}
                </p>

                {!awaitingOtp && (
                  <div className="mt-8">
                    <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                      Email address
                    </label>
                    <div className="h-[56px]">
                      {/* <input
                      type="email"
                      name="email"
                      ref={emailInputRef}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email address"
                      className="w-full h-full px-3 rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[14px] font-poppins"
                      autoComplete="email" inputMode="email" autoCapitalize="off" autoCorrect="off"
                    /> */}
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => {
                          const v = e.target.value;
                          setEmail(v);
                          localStorage.setItem("email", v);
                          setEmailExists("");
                        }}
                        className="w-full h-full px-3 rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[14px] font-poppins"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                      />
                    </div>
                    {emailExists && (
                      <div
                        role="alert"
                        className="mt-2 flex items-center gap-2 text-[12px] text-[#D92D20]"
                      >
                        <BsInfoCircle className="w-[14px] h-[14px] text-[#D92D20]" />
                        <span>{emailExists}</span>
                      </div>
                    )}
                  </div>
                )}

                {awaitingOtp && (
                  <div className="mt-10 w-full max-w-[640px] mx-auto text-center">
                    <div className="flex items-center justify-center gap-3">
                      {otp.map((d, i) => (
                        <input
                          key={i}
                          ref={otpRefs[i]}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          className="w-[44px] h-[44px] rounded-[8px] bg-[#F3F6F9] border border-[#EFF2F5] text-center text-[18px] font-[600]"
                          value={otp[i]}
                          onChange={(e) => handleOtpInputChange(e, i)}
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" && !otp[i] && i > 0)
                              otpRefs[i - 1].current?.focus();
                          }}
                          onPaste={i === 0 ? handleOtpPaste : undefined}
                        />
                      ))}
                    </div>
                    {canResend ? (
                      <p className="text-center text-[12px] font-poppins text-[#303030] mt-4">
                        Don't Receive Code?{" "}
                        <button
                          type="button"
                          className="text-[#00ADEF] underline font-[600]"
                          onClick={async () => {
                            try {
                              const result = await dispatch(
                                sendSignupOtp({ email }),
                              );
                              if (result.payload?.success) {
                                setCanResend(false);
                                setOtpTimeLeft(60);
                                setOtp(["", "", "", "", "", ""]);
                                toast.success("OTP resent to your email");
                              } else {
                                toast.error(
                                  result.payload?.message ||
                                    "Failed to resend OTP",
                                );
                              }
                            } catch (error) {
                              toast.error("Failed to resend OTP");
                            }
                          }}
                        >
                          Resend Code
                        </button>
                      </p>
                    ) : (
                      <p className="text-center text-[12px] font-poppins text-[#303030] mt-4">
                        Resend code on{" "}
                        {String(Math.floor(otpTimeLeft / 60)).padStart(2, "0")}:
                        {String(otpTimeLeft % 60).padStart(2, "0")}
                      </p>
                    )}
                  </div>
                )}

                <div className="mt-12 w-full mx-auto">
                  {awaitingOtp ? (
                    <div className="flex items-center justify-between gap-4 w-full">
                      <PrimaryButton
                        type="button"
                        label="Cancel"
                        className="flex-1 h-[52px] rounded-[8px] bg-[#E1E1E1] text-[#303030]"
                        onClick={() => setAwaitingOtp(false)}
                      />
                      <PrimaryButton
                        type="submit"
                        label="Next"
                        className="flex-1 h-[52px] rounded-[8px]"
                        loading={authLoading}
                        disabled={otp.join("").length !== 6 || authLoading}
                      />
                    </div>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      label="Next"
                      className="w-full h-[52px] rounded-[8px]"
                      loading={authLoading}
                      disabled={!email || authLoading}
                    />
                  )}
                </div>
              </div>
            )}

            {step === 1 && (
              <div className="w-full max-w-[640px] mx-auto">
                <h2 className="text-center text-[24px] md:text-[26px] font-[700] font-poppins text-[#303030]">
                  Complete Your Profile
                </h2>
                <p className="text-center text-[#8C8C8C] mt-2">
                 Add your details to personalise your account.
                </p>

                <div className="mt-8 space-y-5">
                  {/* First name */}
                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                      First name
                    </label>
                    <div className="h-[36px] md:h-[40px]">
                      <input
                        type="text"
                        placeholder="John"
                        value={firstName}
                        onChange={handleFirstNameChange}
                        onBlur={() => setFirstName((v) => v.trim())}
                        className={`w-full h-full px-3 rounded-[6px] border ${nameErrors.first ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[13px] font-poppins`}
                      />
                    </div>
                    {fieldErrors.firstName && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.firstName}
                      </p>
                    )}
                    {nameErrors.first && !fieldErrors.firstName && (
                      <p className="text-[11px] text-red-500 mt-2">
                        Please enter letters only
                      </p>
                    )}
                  </div>

                  {/* Last name */}
                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                      Last name
                    </label>
                    <div className="h-[36px] md:h-[40px]">
                      <input
                        type="text"
                        placeholder="Smith"
                        value={lastName}
                        onChange={handleLastNameChange}
                        onBlur={() => setLastName((v) => v.trim())}
                        className={`w-full h-full px-3 rounded-[6px] border ${nameErrors.last ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[13px] font-poppins`}
                      />
                    </div>
                    {fieldErrors.lastName && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.lastName}
                      </p>
                    )}
                    {nameErrors.last && !fieldErrors.lastName && (
                      <p className="text-[11px] text-red-500 mt-2">
                        Please enter letters only
                      </p>
                    )}
                  </div>

                  {/* Gender + Age row */}
                  <div className="grid grid-cols-5 gap-3">
                    <div className="col-span-3 relative" ref={genderRef}>
                      <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                        Gender
                      </label>
                      <button
                        type="button"
                        onClick={() => setGenderOpen((s) => !s)}
                        className="w-full h-[40px] px-3 rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] text-left text-[13px] font-poppins flex items-center justify-between"
                      >
                        <span>{gender}</span>
                        <svg
                          className={`w-4 h-4 text-[#303030] transition-transform ${genderOpen ? "rotate-180" : ""}`}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                      <div
                        className={`absolute left-0 right-0 mt-2 origin-top transition-all duration-200 ${genderOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"} bg-white border border-[#EFF2F5] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] z-50`}
                      >
                        <div className="max-h-[200px] overflow-auto py-2">
                          {genderOptions.map((g) => (
                            <button
                              key={g}
                              type="button"
                              onClick={() => {
                                setGender(g);
                                setGenderOpen(false);
                              }}
                              className={`w-full text-left px-3 py-2 text-[13px] font-poppins hover:bg-[#F3F6F9] ${g === gender ? "bg-[#EAF7FF] text-[#00ADEF]" : "text-[#303030]"}`}
                            >
                              {g}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                        Age
                      </label>
                      <div className="h-[36px] md:h-[40px]">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          placeholder="23"
                          value={age}
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^0-9]/g, "");
                            if (val.length <= 2) {
                              setAge(val);
                              setFieldErrors((s) => ({ ...s, age: "" }));
                            }
                          }}
                          onBlur={() => {
                            const val = parseInt(age, 10);
                            if (age && (val < 5 || val > 95)) {
                              setFieldErrors((s) => ({
                                ...s,
                                age: "Age must be between 5 and 95",
                              }));
                            }
                          }}
                          className={`w-full h-full px-3 rounded-[6px] border ${fieldErrors.age ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[13px] font-poppins`}
                        />
                      </div>
                      {fieldErrors.age && (
                        <p className="text-[11px] text-red-500 mt-2">
                          {fieldErrors.age}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Phone number with flags */}
                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                      Phone number
                    </label>
                    <div className="h-[40px]">
                      <PhoneInput
                        country={"au"}
                        enableSearch
                        countryCodeEditable={false}
                        value={phone}
                        onChange={(value) => setPhone(value)}
                        placeholder="412 345 678"
                        inputStyle={{
                          width: "100%",
                          height: "40px",
                          background: "#F3F6F9",
                          border: "1px solid #EFF2F5",
                          borderRadius: 6,
                          paddingLeft: 95,
                          fontFamily: "Poppins, sans-serif",
                          fontSize: 13,
                          color: "#303030",
                        }}
                        buttonStyle={{
                          background: "#F3F6F9",
                          border: "none",
                          borderTopLeftRadius: 6,
                          borderBottomLeftRadius: 6,
                          width: 85,
                          paddingLeft: 8,
                        }}
                        dropdownStyle={{ borderRadius: 8 }}
                      />
                    </div>
                    {fieldErrors.phone && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.phone}
                      </p>
                    )}
                  </div>

                  {/* State */}
                  <div className="mb-3">
                    <SearchableSelect
                      variant="desktop"
                      label="State"
                      placeholder="Select state"
                      options={stateOptions}
                      value={selectedState}
                      onChange={(val) => {
                        setSelectedState(val || "");
                        if (fieldErrors.selectedState)
                          setFieldErrors((prev) => ({
                            ...prev,
                            selectedState: "",
                          }));
                      }}
                      error={fieldErrors.selectedState}
                    />
                  </div>

                  {/* Suburb dropdown (Searchable inside) */}
                  <div className="mb-3">
                    <SearchableSelect
                      variant="desktop"
                      label="Suburb"
                      placeholder={
                        selectedState ? "Select suburb" : "Select state first"
                      }
                      options={selectedState ? suburbOptions : []}
                      virtual={true}
                      value={suburb}
                      disabled={!selectedState || suburbLoading}
                      loading={suburbLoading}
                      onChange={(val) => {
                        setSuburb(val || "");
                        if (fieldErrors.suburb)
                          setFieldErrors((prev) => ({ ...prev, suburb: "" }));
                      }}
                      error={fieldErrors.suburb}
                    />
                  </div>

                  {/* Postal code */}
                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">
                      Postal Code{" "}
                      <span className="text-[#8C8C8C] font-[400] text-[11px] ml-1">
                        (Optional)
                      </span>
                    </label>
                    <div className="h-[40px]">
                      <input
                        type="text"
                        placeholder="3000"
                        value={postalCode}
                        onChange={(e) => {
                          const cleaned = String(e.target.value || "")
                            .replace(/[^0-9]/g, "")
                            .slice(0, 4);
                          setPostalCode(cleaned);
                          if (fieldErrors.postalCode)
                            setFieldErrors((prev) => ({
                              ...prev,
                              postalCode: "",
                            }));
                        }}
                        onBlur={() =>
                          setPostalCode((v) => String(v || "").trim())
                        }
                        className={`w-full h-full px-3 rounded-[6px] border ${fieldErrors.postalCode ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[13px] font-poppins`}
                      />
                    </div>
                    {fieldErrors.postalCode && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.postalCode}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex justify-between mt-10 w-full gap-4">
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(0)}
                    className="flex-1 h-[52px] rounded-[8px] bg-[#E1E1E1] text-[#303030]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Next"
                    loading={profileLoading}
                    className="flex-1 h-[52px] rounded-[8px]"
                  />
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="w-full max-w-[640px] mx-auto">
                <h2 className="text-center text-[24px] md:text-[26px] font-[700] font-poppins text-[#303030]">
                  Secure Your Account
                </h2>
                <p className="text-center text-[#8C8C8C] mt-2">
                  Create a strong password to protect your account.
                </p>

                <div className="mt-8 space-y-4">
                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#1A1B1D] mb-2">
                      Password
                    </label>
                    <div className="h-[40px]">
                      <div className="relative h-full">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onBlur={validatePasswordOnly}
                          className="w-full h-full pr-10 pl-3 rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[13px] font-poppins"
                        />
                        <button
                          type="button"
                          aria-label="Toggle password visibility"
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8C8C8C] z-10 w-6 h-6 flex items-center justify-center"
                          onClick={() => setShowPassword((s) => !s)}
                        >
                          {showPassword ? (
                            // eye (when password is visible, show eye icon to indicate you can hide it)
                            <svg
                              className="w-4 h-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <circle
                                cx="12"
                                cy="12"
                                r="3"
                                stroke="currentColor"
                                strokeWidth="1.6"
                              />
                            </svg>
                          ) : (
                            // eye-off (when password is hidden, show eye-slash icon to indicate you can show it)
                            <svg
                              className="w-4 h-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 3l18 18"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.5 6.2A9.7 9.7 0 0112 6c6 0 10 6 10 6s-.62 1.05-1.82 2.33M6.82 6.82C4.64 8.25 3 10 3 12c0 0 4 6 10 6 1.03 0 2-.16 2.9-.46"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.88 9.88A3 3 0 0012 15a3 3 0 002.12-.88"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    {fieldErrors.password && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.password}
                      </p>
                    )}
                    <p className="text-[11px] font-poppins text-[#8C8C8C] mt-2">
                      Hint: 8+ characters, 1 number, 1 special character
                    </p>
                  </div>

                  <div>
                    <label className="block text-[12px] font-[600] font-poppins text-[#1A1B1D] mb-2">
                      Confirm Password
                    </label>
                    <div className="h-[40px]">
                      <div className="relative h-full">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="••••••••"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          onBlur={validateConfirmOnly}
                          className="w-full h-full pr-10 pl-3 rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[13px] font-poppins"
                        />
                        <button
                          type="button"
                          aria-label="Toggle confirm password visibility"
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8C8C8C] z-10 w-6 h-6 flex items-center justify-center"
                          onClick={() => setShowConfirmPassword((s) => !s)}
                        >
                          {showConfirmPassword ? (
                            // eye (when password is visible, show eye icon to indicate you can hide it)
                            <svg
                              className="w-4 h-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <circle
                                cx="12"
                                cy="12"
                                r="3"
                                stroke="currentColor"
                                strokeWidth="1.6"
                              />
                            </svg>
                          ) : (
                            // eye-off (when password is hidden, show eye-slash icon to indicate you can show it)
                            <svg
                              className="w-4 h-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 3l18 18"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.5 6.2A9.7 9.7 0 0112 6c6 0 10 6 10 6s-.62 1.05-1.82 2.33M6.82 6.82C4.64 8.25 3 10 3 12c0 0 4 6 10 6 1.03 0 2-.16 2.9-.46"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.88 9.88A3 3 0 0012 15a3 3 0 002.12-.88"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    {fieldErrors.confirmPassword && (
                      <p className="text-[11px] text-red-500 mt-2">
                        {fieldErrors.confirmPassword}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex justify-between mt-10 w-full gap-4">
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(1)}
                    className="flex-1 h-[52px] rounded-[8px] bg-[#E1E1E1] text-[#303030]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Next"
                    loading={authLoading}
                    className="flex-1 h-[52px] rounded-[8px]"
                  />
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="w-full max-w-[640px] mx-auto">
                {/* Combined price + features card */}
                <div className="rounded-[12px] border border-[#EFF2F5] bg-white overflow-hidden shadow-[0_8px_24px_rgba(0,0,0,0.08)]">
                  <div className="flex items-stretch">
                    {/* Blue price tile inside the same card */}
                    <div
                      className="w-[280px] md:w-[320px]"
                      style={{ background: "#13A0E1" }}
                    >
                      <div className="h-[200px] flex items-center justify-center">
                        <div className="text-center text-white">
                          <div className="text-[32px] font-[600] font-poppins">
                            $49.99
                            <span className="text-[12px] font-[600] ml-1 align-middle opacity-90">
                              /year
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Features list */}
                    <div className="flex-1 p-5">
                      <div className="text-[12px] font-poppins mb-2">
                        <span className="text-[#6B6B6B]">Everything on </span>
                        <span className="font-[700] text-[#303030]">Plan</span>:
                      </div>
                      <ul className="space-y-2 text-[12px] font-poppins text-[#303030]">
                        {[
                          "Many offers available",
                          "Benefits and savings",
                          "1 year membership",
                          "Exclusive experience",
                          "Digital & easy",
                        ].map((text) => (
                          <li key={text} className="flex items-center gap-2">
                            <span
                              className="inline-flex items-center justify-center w-[18px] h-[18px] rounded-full"
                              style={{ background: "#13A0E1" }}
                            >
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 10.5l3 3 7-7"
                                  stroke="#FFFFFF"
                                  strokeWidth="2.2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <span>{text}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Support a Cause card */}
                <div className="mt-3 rounded-[12px] border border-[#EFF2F5] bg-white shadow-[0_8px_24px_rgba(0,0,0,0.08)]">
                  <div className="p-5 md:p-6">
                    <div className="text-[12px] mb-2">
                      <span className="text-[#1A1B1D] font-[600]">
                        Support a Cause
                      </span>{" "}
                      <span className="text-[10px] text-[#8C8C8C]">
                        (Optional)
                      </span>
                    </div>
                    <div className="space-y-3">
                      <div className="relative">
                        <SearchableSelect
                          variant="desktop"
                          label="Fundraiser Category"
                          placeholder="Select category"
                          options={memberVisibleFundraiserCategoryOptions}
                          value={fundCategory}
                          defaultActiveFirstOption={false}
                          onFocus={() => {
                            setFundSubcatOpen(false);
                          }}
                          onChange={(value) => {
                            handleFundraiserCategoryChange(value || "");
                          }}
                        />
                      </div>
                      {(!fundCategory ||
                        selectedCategoryRequiresSubcategory) && (
                        <div className="relative" ref={fundSubcatRef}>
                          <div className="text-[12px] font-[600] text-[#1A1B1D] mb-1">
                            Sub-category
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setFundSubcatOpen((s) => !s);
                            }}
                            className="w-full min-h-[40px] rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] px-3 py-2 text-[13px] font-poppins flex items-center justify-between"
                          >
                            <div className="flex flex-wrap gap-1 items-center flex-1">
                              {fundSubcatIds.length === 0 ? (
                                <span className="text-[#8C8C8C]">
                                  Select sub-category
                                </span>
                              ) : (
                                (subCategories || [])
                                  .filter((s) =>
                                    fundSubcatIds.includes(s._id || s.id),
                                  )
                                  .map((s) => (
                                    <span
                                      key={s._id || s.id}
                                      className="inline-flex items-center gap-1 px-2 py-1 bg-white border border-[#E1E1E1] rounded-full text-[11px] text-[#303030] hover:bg-[#F8F9FA] transition-colors"
                                    >
                                      {s.title}
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removeSubCategoryChip(s._id || s.id);
                                        }}
                                        className="ml-1 text-[#8C8C8C] hover:text-[#FF4444] transition-colors"
                                        aria-label="Remove"
                                      >
                                        <svg
                                          className="w-3 h-3"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 5l10 10M15 5L5 15"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                          />
                                        </svg>
                                      </button>
                                    </span>
                                  ))
                              )}
                            </div>
                            <svg
                              className={`w-4 h-4 text-[#303030] transition-transform ${fundSubcatOpen ? "rotate-180" : ""}`}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </button>
                          <div
                            className={`absolute left-0 right-0 mt-2 origin-top transition-all duration-200 ${fundSubcatOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"} bg-white border border-[#EFF2F5] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] z-50`}
                          >
                            <div className="max-h-[220px] overflow-auto py-2">
                              {!fundCategory ? (
                                <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                  Select category first
                                </div>
                              ) : fundraiserLoading ? (
                                <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                  Loading...
                                </div>
                              ) : subCategories?.length > 0 ? (
                                subCategories.map((c) => {
                                  const cid = c._id || c.id;
                                  const selected = fundSubcatIds.includes(cid);
                                  return (
                                    <button
                                      key={cid}
                                      type="button"
                                      onClick={() => {
                                        toggleSubCategory(c.title);
                                      }}
                                      className={`w-full text-left px-3 py-2 text-[13px] font-poppins transition-all duration-200 hover:bg-[#F3F6F9] ${selected ? "bg-[#EAF7FF] text-[#00ADEF] font-[600]" : "text-[#303030]"}`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <span>{c.title}</span>
                                        {selected && (
                                          <svg
                                            className="w-4 h-4 text-[#00ADEF]"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </button>
                                  );
                                })
                              ) : (
                                <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                  No subcategories available
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="relative">
                        <SearchableSelect
                          variant="desktop"
                          label="Fundraiser Name"
                          placeholder="Select fundraiser"
                          options={fundraiserOptions}
                          value={fundName}
                          loading={fundraiserLoading}
                          selectClassName="fundraisers-search-select"
                          defaultActiveFirstOption={false}
                          onSearch={(v) => setFundraiserNameSearch(v || "")}
                          onInputKeyDown={(e) => {
                            if (e?.key !== "Enter") return;
                            const typed = String(
                              fundraiserNameSearch || "",
                            ).trim();
                            if (!typed) return;
                            const exactMatch = fundraiserOptions.some(
                              (opt) => opt?.value === typed,
                            );
                            if (!exactMatch) {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                          }}
                          onFocus={() => {
                            setFundSubcatOpen(false);
                          }}
                          onChange={(value) => {
                            handleFundraiserNameChange(value || "");
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Proceed limited access + Skip link */}
                {/* <div className="mt-4 flex items-center gap-3 text-black">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#000000" strokeWidth="2" />
                  <path d="M12 10v6" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                  <circle cx="12" cy="7" r="1.2" fill="#000000" />
                </svg>
                <span className="text-[12px]">Proceed with limited access, <button type="button" onClick={()=> setShowSkipModal(true)} className="text-[#00ADEF] underline font-[600]">Skip Now</button></span>
              </div> */}

                {/* Bottom Buttons */}
                <div className="flex justify-between mt-6 w-full gap-4">
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(2)}
                    className="flex-1 h-[52px] rounded-[8px] bg-[#E1E1E1] text-[#303030]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Proceed"
                    loading={subscriptionLoading}
                    className="flex-1 h-[52px] rounded-[8px]"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Functional footer only (replaces previous static image) */}
      <div
        className={`${
          step === 0 && awaitingOtp
            ? "mt-12 md:mt-12 lg:mt-12 2xl:mt-12 mb-6"
            : step === 0
              ? "mt-8 md:mt-8 lg:mt-4 2xl:mt-8 mb-6"
              : "mt-12 md:mt-12 lg:mt-4 mb-6"
        }`}
      >
        <SwoodleFooter
          enableEntranceAnimation={true}
          containerStyle={{
            width: "100%",
            maxWidth: "min(1920px, calc(100vw - 2vw))",
            margin: "0 auto",
          }}
        />
      </div>

      {/* Skip Modal */}
      {/* {showSkipModal && (
        <div className="fixed inset-0 z-[100]">
          <div className="absolute inset-0 bg-black/50" onClick={()=> setShowSkipModal(false)} />
          <div className="absolute inset-0 flex items-center justify-center px-6">
            <div className="w-full max-w-[420px] bg-white rounded-[14px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-8 text-center">
              <div className="mx-auto mb-4 w-[64px] h-[64px] rounded-full flex items-center justify-center bg-white" style={{boxShadow:'0 0 0 2px #13A0E1 inset'}}>
                <svg width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10.5l3 3 7-7" stroke="#13A0E1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-[20px] font-[800] text-[#303030]">Account Created Successfully</h3>
              <p className="mt-3 text-[13px] text-[#8C8C8C] leading-6">Your Swoodle account is now active. Upgrade anytime to unlock full subscription benefits.</p>
              <button type="button" onClick={()=>{ try{ localStorage.removeItem("memberSetup.step"); localStorage.removeItem("memberSetup.email"); localStorage.removeItem("userProfile"); localStorage.removeItem("userPassword"); localStorage.removeItem("memberSetup.fund"); }catch(_){}; handleSkipLoginDeepLink(); }} className="mt-6 w-full h-[48px] rounded-[10px] text-white font-[800]" style={{background:'#13A0E1'}}>Log In</button>
            </div>
          </div>
        </div>
      )} */}
    </form>
  );
};

export default DesktopView;
